export default {
  "foot": {
    "title": "Jugadores de Century Games",
    "p1": "Escribe tu ID de Usuario y paga la recarga. La cantidad aparecerá directamente en tu cuenta asociada. Si no lo hace, refresca el juego o contacta con atención al cliente si fuese necesario.",
    "p2": "Si tienes alguna pregunta, no dudes en contactar con atención al cliente. ¡Gracias por tu apoyo!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Términos de Servicio",
    "policy": "Política de Privacidad",
    "descriptionTitle": "¿Cómo Funciona?"
  },
  "accept": {
    "title": "Esta página utiliza cookies para mejorar tu experiencia de navegación. Lee nuestra <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Política de Privacidad</a> para más información sobre lo que recopilamos en nuestra página. Al continuar utilizando este sitio, aceptas que podamos almacenar y acceder a cookies en tu dispositivo.",
    "decline": "Rechazar",
    "accept": "Aceptar"
  },
  "game": {
    "inapptext": "O Inicia Sesión a Través del Juego",
    "loginfail": "Inicio de Sesión Fallido",
    "logintip": "Si la autorización falla, actualiza a la última versión o prueba con otro navegador.",
    "reloadmsg": "Toca el botón \"Recargar\" para intentar iniciar sesión.",
    "reload": "Recargar",
    "appnotice": "Si quieres iniciar sesión a través de la aplicación del juego, utiliza un navegador externo para abrir la tienda.",
    "changeaccount": "¿Confirmas salir de tu cuenta?",
    "login": "Inicio Sesión",
    "notice": "Atención",
    "confirm": "Confirmar",
    "loginuserid": "ID Usuario",
    "palceholder": "Escribe ID Usuario",
    "okbtn": "Vale",
    "loginbtn": "Iniciar Sesión a través del Juego",
    "changebtn": "O Iniciar Sesión con ID de Usuario",
    "useTitle": "CUENTA",
    "checkBtn": "Comprobar",
    "findid": "¿No pudiste encontrar tu ID de Usuario?",
    "checktext": "Normalmente se encuentra en ajustes, toca la interrogación para obtener más ayuda.",
    "username": "Nombre:",
    "userId": "ID Usuario:",
    "packageTitle": "CANTIDAD A RECARGAR",
    "edit": "Editar",
    "paymentTitle": "FORMA DE PAGO",
    "total": "Total",
    "goPay": "Pagar Ahora",
    "noSelectPackageTips": "No has seleccionado cantidad",
    "payFail": "PAGO FALLIDO",
    "camelPayfail": "Pago Fallido",
    "payFailTips1": "Por favor, contacta con Atención al Cliente de Adyen",
    "payFailTips2": "Por favor, contacta con Atención al Cliente de Paypal",
    "paySuccess": "PAGO REALIZADO",
    "paySuccessTips2": "¡Recarga el juego primero antes de contactar con Atención al Cliente por no recibir tu compra!",
    "camelPaySuccess": "Pago Realizado",
    "transactionId": "ID Transacción",
    "paySuccessTips": "La entrega del artículo puede tardar un momento, espera",
    "deliveryFail": "ENTREGA FALLIDA",
    "deliveryFailTips": "Por favor, contacta con Atención al Cliente",
    "orderTitle": "Resumen de pedido",
    "paidWith": "Forma de Pago",
    "orderID": "ID Transacción",
    "payStatus": "Estado del Pago",
    "orderTotal": "Precio Total",
    "transactionDate": "Fecha de Transacción",
    "goOnPay": "Volver a Comprar",
    "getInvoice": "Factura",
    "camelDeliveryFail": "Fallo en la Entrega",
    "confirmOrder": "CONFIRMACIÓN DEL PEDIDO",
    "confirmFollow": "Por favor, confirma lo siguiente:",
    "nickname": "Nombre",
    "packageName": "Artículos",
    "totalPayment": "Precio Total",
    "confirmPayWith": "Método de Pago",
    "confirmAndGoOn": "Confirmar y Proceder con el Pago",
    "orderCancel": "Cancelar",
    "getInvoiceTitle": "ENVIAR POR CORREO",
    "getInvoiceTips": "Si quieres recibir la factura en tu correo, escribe una dirección.",
    "getInvoiceTips1": "Escribe tu correo para recibir la factura",
    "getInvoiceTips2": "Aceptas nuestra recopilación y almacenamiento de tu dirección de correo.",
    "getInvoiceTips3": "Aceptas recibir correos sobre descuentos, promociones y más sobre nuestros juegos por correo electrónico.",
    "invoiceSend": "Enviar",
    "sendSuccess": "Correo con la Factura Enviado",
    "id404": "ID de usuario no encontrada",
    "packageLoadingText": "Actualizando artículos de la tienda...",
    "taxTips": "Impuestos incluidos",
    "adyenTips": "El servicio de pago es proporcionado por Adyen, que opera bajo licencia bancaria y está supervisado por el Banco Central Holandés. Si tienes alguna consulta sobre sus Certificaciones, consulta <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. En relación a cómo protegen tus datos, consulta <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "El servicio de pago es proporcionado por PayPal. En relación a cómo protegen tus datos, consulta <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "Tu país/región preferido es ${servercountry}. ¿Te gustaría cambiar de país y moneda?",
    "paypalBtn": "Pagar Ahora con Tarjeta",
    "paypalOr": "O",
    "paypalCard1": "Nombre del Titular de la Tarjeta (opcional)",
    "paypalCard2": "Número de Tarjeta",
    "checkUserID": "Conectar",
    "success": "ÉXITO",
    "changeCurrencyContent": "¿Te gustaría cambiar la región y la moneda para que coincidan con tu configuración del juego: ${servercountry}？",
    "productDescription": "Los Dólares de Granja son un equivalente en efectivo que se puede usar para comprar cualquier paquete y ofertas en el juego.",
    "payButton": "PAGAR",
    "userIdNotice": "Por favor, escribe tu ID de Usuario para conectar tu cuenta de juego",
    "account": "Cuenta",
    "card": "Tarjeta",
    "notification": "Escribe tu ID de Usuario para vincular tu cuenta, selecciona los artículos deseados y luego paga con tu método de pago preferido. Tras reiniciar el juego, los artículos comprados aparecerán en tu cuenta, listos para usar.\r\n\r\nSi tienes alguna duda, contacta con el servicio de atención al cliente dentro del juego.",
    "rongluRank": "Nivel Calefactor:",
    "tips": "¿Cómo usar esto?",
    "checkTIps1": "He leído y acepto la <a :href=\"policyUrl\">\"Política de Privacidad\"</a>, los <a :href=\"serviceURl\">\"Términos de Servicio\"</a> y los <a :href=\"paymentURl\">\"Términos de Pago\"</a>.",
    "checkTIps2": "Por favor, lee y marca la casilla de verificación",
    "selectTips": "(Se seleccionará la moneda más reciente en el juego)",
    "koPayTips": "Si tu tarjeta bancaria usó el won surcoreano como moneda extranjera, se usará el servicio de conversión dinámica de moneda (DCC) y el intermediario externo (no este sitio web) podría cobrarte una tarifa adicional para procesar la solicitud.",
    "PayTips": ""
  },
  "invoice": {
    "title": "Factura",
    "transactionId": "ID Transacción",
    "transactionDate": "Fecha Transacción",
    "totalAmount": "Cantidad Total",
    "paymentMethod": "Forma de Pago",
    "description": "Descripción",
    "game": "Juego",
    "quantity": "Cantidad",
    "price": "Precio",
    "amount": "Cantidad",
    "total": "Cantidad Total",
    "footTitle": "Notas",
    "footContent": "¡Gracias por apoyar a Century Games!",
    "button1": "Obtener Factura",
    "button2": "Volver Sin Factura",
    "giveupInvoice": "No recibirás el recibo por esta compra. ¿Confirmar?"
  },
  "payment": {
    "card": "Tarjeta de Crédito / Tarjeta de Débito",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "PAÍS / REGIÓN",
    "Africa": "África",
    "America": "América",
    "Asia": "Asia",
    "Europe": "Europa",
    "Oceania": "Oceanía",
    "ZA": "Sudáfrica",
    "US": "Estados Unidos",
    "HK": "Hong Kong, China",
    "JP": "Japón",
    "KR": "Corea",
    "SG": "Singapur",
    "SA": "Arabia Saudita",
    "IQ": "Iraq",
    "TW": "Taiwán, China",
    "TH": "Tailandia",
    "GB": "Reino Unido",
    "AU": "Australia",
    "countryLanguage1": "IDIOMA",
    "AE": "Emiratos Árabes Unidos",
    "DE": "Alemania",
    "PT": "Portugal",
    "RU": "Rusia",
    "ES": "España",
    "CH": "Suiza",
    "TR": "Turquía",
    "KW": "Kuwait",
    "QA": "Catar",
    "PL": "Polonia",
    "ID": "Indonesia",
    "IT": "Italia",
    "IN": "India",
    "FR": "Francia",
    "CA": "Canadá",
    "NL": "Países Bajos",
    "AT": "Austria",
    "RS": "Serbia",
    "SE": "Suecia",
    "MY": "Malasia",
    "BE": "Bélgica",
    "DK": "Dinamarca",
    "FI": "Finlandia",
    "PH": "Filipinas",
    "NO": "Noruega",
    "BR": "Brasil",
    "NZ": "Nueva Zelanda",
    "UA": "Ucrania",
    "RO": "Rumania"
  },
  "extra_info": {
    "kingdom": "Región: #"
  },
  "adyen": {
    "note": "El servicio de pago es proporcionado por Adyen, que ofrece transacciones seguras con el más alto nivel de certificación PCI DSS de organizaciones internacionales de tarjetas de crédito que admiten pagos con tarjeta tanto nacionales como internacionales.",
    "note2": "Nota: Marca \"Guardar para el próximo pago\" para guardar la información de tu tarjeta de pago en tu navegador actual para futuros pagos."
  },
  "pay": {
    "error1": "Si algo va mal, por favor, prueba más tarde o usa otro método de pago. Contacta con atención al cliente si tienes más dudas."
  },
  "meta": {
    "title": "Tienda Family Farm Adventure",
    "description": "La Tienda de Family Farm Adventure es la tienda oficial del juego, ofreciendo un canal de recarga y paquetes con descuento para los jugadores.",
    "keywords": "granja, cultivo, mercado, mejora, exploración, mapa, personaje, nivel, simulación, estrategia, pagar, tienda, recarga, pago"
  }
};


// WEBPACK FOOTER //
// ./src/lang/ES.js